/**
 * The overline section caption shared by the drawer's expanded-issue Why and
 * How sections ("Why this was flagged" / "How to fix this issue"), so the two
 * stay byte-identical. One home for the caption style - change it once.
 *
 * ``tightTop`` drops the top margin: the Why caption opens flush at the top of
 * the expanded body, while the How caption keeps its margin to separate from
 * the Why content above it.
 */
import React from 'react'
import { Typography } from '@mui/material'
import { poolwerxColors } from '../../../../theme/colors'

const SectionHeading: React.FC<{
  children: React.ReactNode
  tightTop?: boolean
}> = ({ children, tightTop = false }) => (
  <Typography
    variant="overline"
    sx={{
      display: 'block',
      mt: tightTop ? 0 : '13px',
      mb: '5px',
      fontSize: '11px',
      color: poolwerxColors.text.secondary,
      fontWeight: 600,
      letterSpacing: '0.05em',
    }}
  >
    {children}
  </Typography>
)

export default SectionHeading
